module.exports = __webpack_public_path__ + "resources/img/facetec-ui-frame.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-frame.png
// module id = 1365
// module chunks = 0